import {useState} from 'react'
import { useNavigate } from "react-router-dom"

export const useResetPassword = () => {
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(null)
    const navigate = useNavigate()

    const resetPassword = async (email, otp, newPassword, confirmPassword) => {
        setIsLoading(true)
        setError(null)

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/reset-password`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({email, otp, newPassword, confirmPassword}),
            credentials: 'include'
        })
        const json = await response.json()

        if (!response.ok) { //if response is error code, eg 400 then response.ok will be false
            setIsLoading(false)
            setError(json.error)
        }
        if (response.ok) {
            alert('Password Reset Successful')
            navigate('/login')
            setIsLoading(false)
        }
    }

    return ({resetPassword, isLoading, error})
}